import React from "react";

const Contact = () => {
  return (
    <div
      name="contact"
      className="w-full h-screen bg-black text-white sm:pt-0 pt-24 min-h-screen" // Ändrat för att matcha Skills-sektionen
    >
      <div className="max-w-[1000px] p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-yellow-400 text-white">
            Contact
          </p>
          <p className="text-white text-lg py-4">
            Submit the form below or send me an email -
            fredrik.nordberg@hotmail.com
          </p>
        </div>
        <form
          method="POST"
          action="https://getform.io/f/pboxwroa"
          className="flex flex-col max-w-[600px] w-full"
        >
          <input
            className="bg-white p-2"
            type="text"
            placeholder="Name"
            name="name"
          />
          <input
            className="bg-white my-4 p-2"
            type="email"
            placeholder="Email"
            name="email"
          />
          <textarea
            className="bg-white p-2"
            name="message"
            rows="10"
            placeholder="Message"
          ></textarea>
          <button className="text-white border-2 hover:border-yellow-400 px-4 py-3 my-8 mx-auto flex items-center">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact;

